"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _react = _interopRequireWildcard(require("react"));
var _reactRedux = require("react-redux");
var _redux = require("redux");
var _reactRouterDom = require("react-router-dom");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _moment = _interopRequireDefault(require("moment"));
var _constants = require("../constants");
var _extras = require("../helpers/extras");
var _pricing = require("../helpers/pricing");
var _booking = require("../actions/booking");
var _newComponents = require("../new-components");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var VariableExtrasProduct = /*#__PURE__*/function (_Component) {
  function VariableExtrasProduct(props) {
    var _this;
    (0, _classCallCheck2["default"])(this, VariableExtrasProduct);
    _this = _callSuper(this, VariableExtrasProduct, [props]);
    _this.state = {
      ordering: false,
      orderingVariant: null,
      quantity: 1,
      variant: null,
      maxAvailable: null,
      isIncludeAllGuests: _this.props.product.product.type === _constants.EXTRAS.INCLUDE_ALL_GUESTS_TYPE
    };
    _this.canOrder = _this.canOrder.bind(_this);
    _this.updateSelectedVariant = _this.updateSelectedVariant.bind(_this);
    _this.updateQuantity = _this.updateQuantity.bind(_this);
    return _this;
  }
  (0, _inherits2["default"])(VariableExtrasProduct, _Component);
  return (0, _createClass2["default"])(VariableExtrasProduct, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(_, prevState) {
      var _this$props = this.props,
        scrollModalDown = _this$props.scrollModalDown,
        maxQuantity = _this$props.maxQuantity,
        product = _this$props.product,
        booking = _this$props.booking; // maxQuantity is coming from tyw/tsw as boys+girls
      var _this$state = this.state,
        variant = _this$state.variant,
        isIncludeAllGuests = _this$state.isIncludeAllGuests;
      if (prevState.variant !== variant) {
        var _product$product;
        if (scrollModalDown) scrollModalDown();
        var maxAvailableExtras = variant !== null && variant !== void 0 && variant.totalAvailable ? Math.min(Number(variant.totalAvailable), maxQuantity) : maxQuantity;
        maxAvailableExtras = variant !== null && variant !== void 0 && variant.totalAvailablePerYear ? Math.min(maxAvailableExtras, Number(variant.totalAvailablePerYear)) : maxAvailableExtras;
        var maxAvailable = maxAvailableExtras;
        if (!!(product !== null && product !== void 0 && (_product$product = product.product) !== null && _product$product !== void 0 && _product$product.remainingQuantityForBooking)) {
          var _product$product2;
          maxAvailable = (product === null || product === void 0 || (_product$product2 = product.product) === null || _product$product2 === void 0 ? void 0 : _product$product2.remainingQuantityForBooking) < maxAvailableExtras ? product.product.remainingQuantityForBooking : maxAvailableExtras;
        }
        if (isIncludeAllGuests) {
          var boys = booking.numBoys;
          var girls = booking.numGirls;
          var total = boys + girls;
          this.updateQuantity(total);
        }
        this.setState({
          maxAvailable: maxAvailable
        });
      }
    }
  }, {
    key: "getText",
    value: function getText(variant) {
      var product = this.props.product.product;
      var text = "Must be added before ".concat((0, _moment["default"])(product.availableUntil).format('Do MMM'));
      if (variant && (variant.soldOut || !this.canOrder(variant))) {
        text = 'Sold out';
      }
      return /*#__PURE__*/_react["default"].createElement("p", {
        className: "text-md d8-u-color-".concat(variant && variant.soldOut || !product.available ? 'error' : 'primary')
      }, text);
    }
  }, {
    key: "canOrder",
    value: function canOrder(variant) {
      var isIncludeAllGuests = this.state.isIncludeAllGuests;
      var _this$props2 = this.props,
        product = _this$props2.product,
        _this$props2$booking = _this$props2.booking,
        numBoys = _this$props2$booking.numBoys,
        numGirls = _this$props2$booking.numGirls;
      if (isIncludeAllGuests) {
        var quantity = numBoys + numGirls;
        return variant.totalAvailable >= quantity;
      }
      return !!product.product.available && !(variant !== null && variant !== void 0 && variant.soldOut);
    }
  }, {
    key: "updateQuantity",
    value: function updateQuantity(quantity) {
      this.setState({
        quantity: quantity
      });
    }
  }, {
    key: "updateSelectedVariant",
    value: function updateSelectedVariant(event) {
      var variantId = Number.parseInt(event.target.value, 10);
      var variant = this.props.product.productVariants.find(function (pv) {
        return pv.id === variantId;
      }) || null;
      this.setState({
        variant: variant
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      var _this$props$product = this.props.product,
        product = _this$props$product.product,
        productVariants = _this$props$product.productVariants;
      var location = this.props.location;
      var _this$state2 = this.state,
        variant = _this$state2.variant,
        quantity = _this$state2.quantity,
        maxAvailable = _this$state2.maxAvailable,
        isIncludeAllGuests = _this$state2.isIncludeAllGuests;
      var orderingExtra = this.state.ordering && this.state.orderingVariant === variant.id;
      var variantSelect = productVariants.map(function (variantObject) {
        return {
          value: variantObject.id,
          text: variantObject.name
        };
      });
      var imgSrc;
      if (variant && variant.contentImage) {
        imgSrc = variant.contentImage.path;
      } else {
        var productVariantWithImage = productVariants.find(function (v) {
          return v.contentImage;
        });
        if (productVariantWithImage) {
          imgSrc = productVariantWithImage.contentImage.path;
        }
        if (!imgSrc) {
          imgSrc = (0, _extras.getDefaultImage)(product.type, _constants.EXTRAS.COPY);
        }
      }
      var readMoreLink = variant && (variant.readMoreLink || variant.product.readMoreLink);
      var name = variant && variant.name;
      if (variant && variant.product.id === _constants.PRODUCTS.TYW_HOSTESS_ID) {
        name = 'Hostess';
      }
      if (variant && variant.product.id === _constants.PRODUCTS.TYW_ULTRA_ID) {
        name = 'VIP Ultra tickets   ';
      }
      return /*#__PURE__*/_react["default"].createElement(_newComponents.Card, {
        template: "ImageCard",
        imageCardTemplate: "VerticalSplit",
        image: {
          url: imgSrc ? imgSrc : 'https://assets.theyachtweek.com/wp-content/uploads/2023/03/new-TYW_-Croatia_w34_Tam_Koppelaar-140.jpg',
          alt: product.name
        },
        title: product.name,
        key: product.id,
        fullHeight: true
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: "flex flex-column justify-between height-100%"
      }, /*#__PURE__*/_react["default"].createElement("div", null, this.getText(variant)), /*#__PURE__*/_react["default"].createElement("div", {
        className: "padding-y-sm"
      }, /*#__PURE__*/_react["default"].createElement(_newComponents.Select, {
        label: "Select product",
        placeholder: "Select option...",
        options: variantSelect,
        value: variant ? variant.id : null,
        onChange: this.updateSelectedVariant
      }), (variant === null || variant === void 0 ? void 0 : variant.description) && /*#__PURE__*/_react["default"].createElement("div", {
        className: "text-xs margin-bottom-sm"
      }, variant.description), !!maxAvailable && this.canOrder(variant) && !isIncludeAllGuests && /*#__PURE__*/_react["default"].createElement(_newComponents.Select, {
        label: "Quantity",
        value: quantity,
        options: VariableExtrasProduct.getQuantitySelect(maxAvailable),
        onChange: function onChange(e) {
          return _this2.updateQuantity(Number.parseInt(e.target.value, 10));
        }
      })), variant && /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("div", {
        className: "text-component"
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: "flex justify-between items-center"
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: "flex"
      }, /*#__PURE__*/_react["default"].createElement("p", {
        className: "text-sm"
      }, /*#__PURE__*/_react["default"].createElement("span", {
        className: "d8-u-text-bold"
      }, quantity, "x")), /*#__PURE__*/_react["default"].createElement("p", {
        className: "text-sm padding-x-xs"
      }, /*#__PURE__*/_react["default"].createElement("span", {
        className: "d8-u-text-bold"
      }, variant.name || variant.product.description))), /*#__PURE__*/_react["default"].createElement("p", {
        className: "text-sm"
      }, /*#__PURE__*/_react["default"].createElement("span", {
        className: "d8-u-text-bold"
      }, (0, _pricing.formatCurrency)(variant.price / 100, variant.currency)))), /*#__PURE__*/_react["default"].createElement("div", {
        className: "flex justify-between items-center"
      }, /*#__PURE__*/_react["default"].createElement("p", null, /*#__PURE__*/_react["default"].createElement("span", {
        className: "d8-u-text-bold"
      }, "Total:")), /*#__PURE__*/_react["default"].createElement("p", null, /*#__PURE__*/_react["default"].createElement("span", {
        className: "d8-u-text-bold"
      }, (0, _pricing.formatCurrency)(quantity * variant.price / 100, variant.currency))))), /*#__PURE__*/_react["default"].createElement("div", {
        className: "margin-top-md flex grid-gap-md"
      }, this.canOrder(variant) ? /*#__PURE__*/_react["default"].createElement(_reactRouterDom.Link, {
        disabled: orderingExtra,
        to: {
          pathname: "".concat(location.pathname, "/checkout"),
          search: location.search,
          state: {
            productVariants: [{
              variant: variant,
              quantity: quantity
            }]
          }
        },
        className: "btn btn--full-width ".concat(orderingExtra ? 'btn--disabled' : 'btn--primary')
      }, orderingExtra ? 'Ordering...' : 'Purchase') : /*#__PURE__*/_react["default"].createElement(_newComponents.Button, {
        text: "Closed",
        buttonType: _newComponents.BUTTON_TYPES.GHOST,
        disabled: true,
        fullWidth: true
      }), readMoreLink && /*#__PURE__*/_react["default"].createElement("a", {
        className: "btn flex-row-reverse btn--bare",
        href: readMoreLink,
        target: "_blank"
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: "flex-shrink-0 margin-left-sm"
      }, /*#__PURE__*/_react["default"].createElement(_newComponents.Svg, {
        name: "arrow-right"
      })), "Read More")))));
    }
  }], [{
    key: "getQuantitySelect",
    value: function getQuantitySelect(maxAvailable) {
      var quantityArray = [];
      for (var i = 1; i <= maxAvailable; i += 1) {
        quantityArray.push({
          value: i,
          text: i
        });
      }
      return quantityArray;
    }
  }]);
}(_react.Component);
VariableExtrasProduct.propTypes = {
  product: _propTypes["default"].object.isRequired,
  maxQuantity: _propTypes["default"].number,
  location: _propTypes["default"].object.isRequired,
  scrollModalDown: _propTypes["default"].func
};
var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return (0, _redux.bindActionCreators)({
    orderExtrasProduct: _booking.orderExtrasProduct
  }, dispatch);
};
var _default = exports["default"] = (0, _reactRedux.connect)(null, mapDispatchToProps)(VariableExtrasProduct);